import React, { useContext, useState } from 'react'
import { GrSearch } from "react-icons/gr";
import { FaRegCircleUser } from "react-icons/fa6";
import { FaShoppingCart } from "react-icons/fa";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import SummaryApi from '../common';
import { toast } from 'react-toastify'
import { setUserDetails } from '../store/userSlice';
import ROLE from '../common/role';
import Context from '../context';
import Navigetaion from './Navigetaion';

const Header = () => {
  const user = useSelector(state => state?.user?.user)
  console.log(user)
  const dispatch = useDispatch()
  const [menuDisplay, setMenuDisplay] = useState(false)
  const context = useContext(Context)
  const navigate = useNavigate()
  const searchInput = useLocation()
  const URLSearch = new URLSearchParams(searchInput?.search)
  const searchQuery = URLSearch.getAll("q")
  const [search, setSearch] = useState(searchQuery)

  const handleLogout = async () => {
    const fetchData = await fetch(SummaryApi.logout_user.url, {
      method: SummaryApi.logout_user.method,
      credentials: 'include'
    })

    const data = await fetchData.json()

    if (data.success) {
      toast.success(data.message)
      localStorage.removeItem("token");
      dispatch(setUserDetails(null))
      navigate("/")
    }

    if (data.error) {
      toast.error(data.message)
    }

  }

  const handleSearch = (e) => {
    const { value } = e.target
    setSearch(value)

    if (value) {
      navigate(`/search?q=${value}`)
    } else {
      navigate("/search")
    }
  }
  return (
    <div className='shadow-md bg-white fixed w-full z-40 top-0'>
      <Navigetaion />

      <header className='h-30 bg-gray-100'>

        <div className=' h-full container mx-auto flex items-center px-4 justify-between'>
          <div className='py-2 rounded-lg'>
            <Link to={"/"}>

              <img src='https://res.cloudinary.com/dorip8bfj/image/upload/v1770110495/download_r8mwub.png' alt='mulama' className='w-auto h-20 rounded-lg' />

            </Link>
          </div>

          <div className='hidden lg:flex items-center w-full justify-between max-w-3xl border rounded-full focus-within:shadow pl-4 bg-white'>
            <input type='text' placeholder='search product here...' className='w-full py-2 outline-none ' onChange={handleSearch} value={search} />
            <div className='text-lg min-w-[45px] min-h-[45px] bg-green-600 flex items-center justify-center rounded-r-full text-white'>
              <GrSearch />
            </div>
          </div>


          <div className='flex items-center gap-7 w-[200px] h-full'>

            <div className='relative flex justify-center'>

              {
                user?._id && (
                  <div className='text-3xl cursor-pointer relative flex justify-center' onClick={() => setMenuDisplay(preve => !preve)}>
                    {
                      user?.profilePic ? (
                        <img src={user?.profilePic} className='w-6 md:w-7 h-6 md:h-7 rounded-full' alt={user?.name} />
                      ) : (
                        <FaRegCircleUser />
                      )
                    }
                  </div>
                )
              }


              {
                menuDisplay && (
                  <div className="absolute left-0 sm:right-0 top-full mt-2 w-48 bg-white border border-gray-300 shadow-xl rounded-lg z-50">
                    <nav className="flex flex-col space-y-2 bg-white rounded-md">
                      {user?.role === ROLE.ADMIN && (
                        <Link
                          to={"/admin-panel/all-products"}
                          className="block px-4 py-2 text-gray-700 hover:bg-gray-200 rounded transition"
                          onClick={() => setMenuDisplay(prev => !prev)}
                        >
                          Admin Panel
                        </Link>
                      )}
                    </nav>
                  </div>
                )
              }





            </div>

            {
              user?._id && (
                <Link to={"/cart"} className='text-2xl relative'>
                  <span><FaShoppingCart /></span>

                  <div className='bg-green-600 text-white w-5 h-5 rounded-full p-1 flex items-center justify-center absolute -top-2 -right-3'>
                    <p className='text-sm'>{context?.cartProductCount}</p>
                  </div>
                </Link>
              )
            }



            <div className="w-full h-full bg-green-700 hover:bg-green-400 flex items-center justify-center">
              {user?._id ? (
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 rounded-full text-white bg-green-600 hover:bg-green-700 font-semibold"
                >
                  Logout
                </button>
              ) : (
                <Link
                  to="/login"
                  className="w-full h-[50px] flex items-center justify-center rounded-full text-white font-bold"
                >
                  LOGIN
                </Link>
              )}
            </div>


          </div>

        </div>
      </header >
    </div>
  )
}

export default Header
